export const validatePhone = (phone, setPhoneInvalid) => {
  let arr = phone.split('')
  const i = arr.indexOf('_')
  i > -1 ? setPhoneInvalid(true) : setPhoneInvalid(false)
}
